import React, { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Printd } from 'printd';
import { Toast } from 'primereact/toast';
import api from '../api/api';

export const DialogLiquidar = ({ visible, setVisible, liquidar, simular, setLazyParams }) => {
    const d = new Printd();
    const toast = useRef(null);
    const cssText = `
        * {
            font-size: 10px !important;
        }
        #print-content {
            font-family: 'Open Sans', sans-serif;
            width: 100%;
            text-align: left;
        }
        img {
            margin-top: 25px;
            width: 100%;
            max-width: 250px;
            height: auto;
            display: block;
        }
        .header-img {
            display: flex;
            justify-content: center;
        }
        .header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }
        .header h2 {
            margin-bottom: 0px;
        }
        .header h4 {
            margin-top: 7px;
        }
    `;

    const listaLiquidar = liquidar.map((data) => {
        
        // Função para calcular o subtotal por secretariaId
        const calculateSubtotalsBySecretaria = () => {
            const subtotals = {};
            data.liquidacoes.forEach(item => {
                const secretariaId = item.secretariaId;
                if (!subtotals[secretariaId]) {
                    subtotals[secretariaId] = {
                        totalSaldoAtual: 0,
                        totalValorALiquidar: 0,
                        totalValorRetencao: 0,
                    };
                }
                subtotals[secretariaId].totalSaldoAtual += item.saldoAtual || 0;
                subtotals[secretariaId].totalValorALiquidar += item.valorALiquidar || 0;
                subtotals[secretariaId].totalValorRetencao += item.valorRetencao || 0;
            });
            return subtotals;
        };

        const sortedLiquidacoes = data.liquidacoes.sort((a, b) => {
            if (a.secretariaId !== b.secretariaId) {
                return a.secretariaId - b.secretariaId;
            }
            if (a.ficha !== b.ficha) {
                return a.ficha - b.ficha;
            }
            return a.numeroEmpenho - b.numeroEmpenho;
        });

        const renderLiquidacoesFaltantesRows = () => {
            if (!data.liquidacoesFaltantes || !Array.isArray(data.liquidacoesFaltantes) || data.liquidacoesFaltantes.length === 0) {
                return <tr><td colSpan={5} align="center">Nenhuma liquidação pendente</td></tr>;
            }

            const liquidacoesFaltantes = [];
            data.liquidacoesFaltantes.forEach((item, index) => {
                liquidacoesFaltantes.push(
                    <tr key={index}>
                        <td align='center'><b>{item.id || 'N/A'}</b></td>
                        <td align='center'><b>{item.ficha || 'N/A'}</b></td>
                        <td align='center'><b>{item.numeroEmpenho || 'N/A'}</b></td>
                        <td align='center'><b>R$ {(item.valorFaltanteALiquidar || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                        <td align='center'><b>R$ {(item.valorRetencaoALiquidar || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                    </tr>
                );
            });

            const totalValorFaltanteALiquidar = data.liquidacoesFaltantes.reduce((total, item) => total + (item.valorFaltanteALiquidar || 0), 0);
            const totalValorRetencaoALiquidar = data.liquidacoesFaltantes.reduce((total, item) => total + (item.valorRetencaoALiquidar || 0), 0);

            liquidacoesFaltantes.push(
                <tr key="total">
                    <th colSpan={3} style={{ textAlign: 'right' }}><i>Total Geral:</i></th>
                    <td align='center'><b>R$ {totalValorFaltanteALiquidar.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                    <td align='center'><b>R$ {totalValorRetencaoALiquidar.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                </tr>
            );

            return liquidacoesFaltantes;
        };

        const renderLiquidacoesRows = () => {
            const subtotals = calculateSubtotalsBySecretaria();
            const liquidacoes = [];
            let lastSecretariaId = null;

            sortedLiquidacoes.forEach((item, index) => {
                if (lastSecretariaId !== item.secretariaId && lastSecretariaId !== null) {
                    const subtotal = subtotals[lastSecretariaId];
                    const totalBrutoSecretaria = subtotal.totalValorALiquidar + subtotal.totalValorRetencao;
                    liquidacoes.push(
                        <tr key={`subtotal-${lastSecretariaId}`}>
                            <td colSpan={2} style={{ textAlign: 'right' }}><b>Subtotal Secretaria {lastSecretariaId}:</b></td>
                            <td align='center'><b>R$ {subtotal.totalSaldoAtual.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                            <td align='center'><b>R$ {subtotal.totalValorALiquidar.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                            <td align='center'><b>R$ {subtotal.totalValorRetencao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                            <td align='center'><b>R$ {totalBrutoSecretaria.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                            <td></td>
                        </tr>
                    );
                }

                const usoEmpenho = ((item.valorEmpenho - item.saldoAtual) / item.valorEmpenho) * 100;
                const totalBrutoItem = item.valorALiquidar + item.valorRetencao;

                liquidacoes.push(
                    <tr key={index} style={{ color: usoEmpenho > 70 ? 'red' : 'black', fontWeight: usoEmpenho > 70 ? 'bold' : 'normal' }}>
                        <td width="10%" align='center'><span>{item.secretariaId}</span></td>
                        <td width="10%" align='center'><span>{item.numeroEmpenho} - {item.ficha} - {item.fornecedorCodigo}</span></td>
                        <td width="10%" align='center'><span>R$ {(item.saldoAtual || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                        <td width="10%" align='center'><span>R$ {(item.valorALiquidar || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                        <td width="10%" align='center'><span>R$ {(item.valorRetencao || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                        <td width="10%" align='center'><span>R$ {totalBrutoItem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                        <td width="10%" align='center'><span>{(usoEmpenho || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                    </tr>
                );
                lastSecretariaId = item.secretariaId;
            });

            if (lastSecretariaId !== null) {
                const subtotal = subtotals[lastSecretariaId];
                const totalBrutoSecretaria = subtotal.totalValorALiquidar + subtotal.totalValorRetencao;
                liquidacoes.push(
                    <tr key={`subtotal-${lastSecretariaId}`}>
                        <td colSpan={2} style={{ textAlign: 'right' }}><b>Subtotal Secretaria {lastSecretariaId}:</b></td>
                        <td align='center'><b>R$ {subtotal.totalSaldoAtual.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                        <td align='center'><b>R$ {subtotal.totalValorALiquidar.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                        <td align='center'><b>R$ {subtotal.totalValorRetencao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                        <td align='center'><b>R$ {totalBrutoSecretaria.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                        <td></td>
                    </tr>
                );
            }

            const totalSaldoAtual = data.liquidacoes.reduce((total, item) => total + (item.saldoAtual || 0), 0);
            const totalValorRetencao = data.liquidacoes.reduce((total, item) => total + (item.valorRetencao || 0), 0);
            const totalValorALiquidar = data.liquidacoes.reduce((total, item) => total + (item.valorALiquidar || 0), 0);
            const totalBrutoGeral = totalValorALiquidar + totalValorRetencao;

            liquidacoes.push(
                <tr key="total">
                    <th colSpan={2} style={{ textAlign: 'right' }}><i>Total Geral:</i></th>
                    <td align='center'><span><b>R$ {totalSaldoAtual.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                    <td align='center'><span><b>R$ {totalValorALiquidar.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                    <td align='center'><span><b>R$ {totalValorRetencao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                    <td align='center'><span><b>R$ {totalBrutoGeral.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                    <td></td>
                </tr>
            );
            return liquidacoes;
        };

        const renderFaturasRows = () => {
            const faturas = data.faturas.map((item, index) => (
                <tr key={index}>
                    <td width="10%" align='center'><span>{item.numero}</span></td>
                    <td width="10%" align='center'><span>R$ {(item.valorLiquidado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                    <td width="10%" align='center'><span>R$ {(item.valorRetencao || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                    <td width="10%" align='center'><span>R$ {((item.valorLiquidado || 0) + (item.valorRetencao || 0)).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                </tr>
            ));
            const totalValorRetencao = data.faturas.reduce((total, item) => total + (item.valorRetencao || 0), 0);
            const totalValorTotal = data.faturas.reduce((total, item) => total + (item.valorLiquidado || 0), 0);
            const totalValorBruto = totalValorTotal + totalValorRetencao;
            faturas.push(
                <tr key="total">
                    <th width="100px"><i>Total:</i></th>
                    <td align='center'><span><b>R$ {totalValorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                    <td align='center'><span><b>R$ {totalValorRetencao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                    <td align='center'><span><b>R$ {totalValorBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                </tr>
            );
            return faturas;
        };

        const renderLiquidacoesQtdeRows = () => {
            const liquidacoes = data.liquidacoesQtde.map((item, index) => (
                <tr key={index}>
                    <td width="10%" align='center'><span>{item.numeroEmpenho}</span></td>
                    <td width="10%" align='center'><span>{item.descricaoEmpenho}</span></td>
                    <td width="10%" align='center'><span>{item.codigo}</span></td>
                    <td width="10%" align='center'><span>{(item.qtdeEmp || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                    <td width="10%" align='center'><span>{(item.qtdeLiq || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                    <td width="10%" align='center'><span>R$ {(item.valorEmp || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                    <td width="10%" align='center'><span>R$ {(item.valorTotalEmp || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                    <td width="10%" align='center'><span>R$ {(item.valorTotalFat || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
                </tr>
            ));
            const totalValorEmpenhado = data.liquidacoesQtde.reduce((total, item) => total + (item.valorTotalEmp || 0), 0);
            const totalValorFaturado = data.liquidacoesQtde.reduce((total, item) => total + (item.valorTotalFat || 0), 0);
            liquidacoes.push(
                <tr key="total">
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <th width="100px"><i>Total:</i></th>
                    <td align='center'><span><b>R$ {totalValorEmpenhado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                    <td align='center'><span><b>R$ {totalValorFaturado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></span></td>
                </tr>
            );
            return liquidacoes;
        };

        return (
            <div>
                <h2>Faturas:</h2>
                <table width="100%" border="1" style={{ 'borderCollapse': 'collapse' }} cellPadding={3} cellSpacing={0}>
                    <thead>
                        <tr>
                            <th width="100px"><i>N° Fatura</i></th>
                            <th width="100px"><i>Valor Total</i></th>
                            <th width="100px"><i>Valor Retenção</i></th>
                            <th width="100px"><i>Valor Bruto</i></th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderFaturasRows()}
                    </tbody>
                </table>

                <h2>Liquidações por Valor:</h2>
                <table width="100%" border="1" style={{ 'borderCollapse': 'collapse' }} cellPadding={3} cellSpacing={0}>
                    <thead>
                        <tr>
                            <th width="8%"><i>Sec. Id</i></th>
                            <th width="12%"><i>N° Empenho - Dotação - Id Fornecedor</i></th>
                            <th width="8%"><i>Saldo Atual Emp.</i></th>
                            <th width="8%"><i>Valor a Liquidar</i></th>
                            <th width="8%"><i>Valor Retenção</i></th>
                            <th width="8%"><i>Valor Bruto</i></th>
                            <th width="8%"><i>% Uso Empenho</i></th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderLiquidacoesRows()}
                    </tbody>
                </table>

                {data.liquidacoesQtde && (
                    <>
                        <h2>Liquidações por Qtde:</h2>
                        <table width="100%" border="1" style={{ 'borderCollapse': 'collapse' }} cellPadding={3} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th width="100px"><i>N° Empenho</i></th>
                                    <th width="100px"><i>Descrição</i></th>
                                    <th width="100px"><i>Código</i></th>
                                    <th width="100px"><i>Qtde Emp</i></th>
                                    <th width="100px"><i>Qtde a Liq.</i></th>
                                    <th width="100px"><i>Valor Un</i></th>
                                    <th width="100px"><i>Valor Total Emp.</i></th>
                                    <th width="100px"><i>Valor Total Fat.</i></th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderLiquidacoesQtdeRows()}
                            </tbody>
                        </table>
                    </>
                )}

                <h2>Liquidações Restante por Falta de Saldo:</h2>
                <table width="100%" border="1" style={{ 'borderCollapse': 'collapse' }} cellPadding={3} cellSpacing={0}>
                    <thead>
                        <tr>
                            <th width="8%"><i>Id</i></th>
                            <th width="12%"><i>Ficha</i></th>
                            <th width="8%"><i>Empenho</i></th>
                            <th width="8%"><i>Valor a Liquidar</i></th>
                            <th width="8%"><i>Valor Retenção a Liquidar</i></th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderLiquidacoesFaltantesRows()}
                    </tbody>
                </table>
            </div>
        );
    });

    const handlePrintClick = () => {
        d.print(document.getElementById("print-content"), [cssText]);
    };

    const handleLiquidar = async () => {
        try {
            await Promise.all(liquidar[0].faturas.map(async fatura => {
                let faturaCompleta = await api.get(`faturas/${fatura.id}`);
                faturaCompleta.data.dataLiquidacao = new Date().toISOString();
                await api.put(`faturas`, faturaCompleta.data);
            }));
            await Promise.all(liquidar[0].liquidacoes.map(async liquidacao => {
                let empenhoCompleto = await api.get(`empenho/${liquidacao.id}`);
                empenhoCompleto.data.valorLiquidado = liquidacao.valorALiquidar;
                await api.put(`empenho`, empenhoCompleto.data);
            }));
            simular();
            setVisible(false);
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Liquidação processada com sucesso', life: 3000 });
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao processar a liquidação', life: 3000 });
        }
    };

    const header = (
        <div></div>
    );

    return (
        <Dialog header="Confirmar Liquidação" visible={visible} onHide={() => setVisible(false)} maximizable footer={<div></div>} style={{ width: '90vw' }}>
            <Button label="Imprimir" className="p-button-secondary" icon="pi pi-print" onClick={handlePrintClick} />
            <Toast ref={toast} />
            <div id="print-content">
                {listaLiquidar}
            </div>
        </Dialog>
    );
};